export const IRISH_MOBILE_PREFIXES = ["083", "085", "086", "087", "088", "089"];